<div class="container">
  <div class="page-container">
    <div class="header-content">
      <h2>Manage Question Config</h2>
      <button (click)="saveConfig()" color="primary" mat-flat-button>Save Config</button>
    </div>
    <div class="content">
      <div class="w-50-2">
        <form [formGroup]="configForm" class="question-config-form">
          <mat-form-field class="w-100-1">
            <mat-label>Methodology</mat-label>
            <input formControlName="methodology" readonly matInput />
          </mat-form-field>
          <mat-form-field class="w-100-1">
            <mat-label>Report Type</mat-label>
            <mat-select formControlName="reportType" data-cy="select-reportType">
              <mat-option value="Eligibility">Eligibility</mat-option>
              <mat-option value="Periodic">Periodic</mat-option>
              <mat-option value="Disturbance">Disturbance</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="w-100-1">
            <mat-label>Question Config</mat-label>
            <textarea formControlName="config" matInput></textarea>
          </mat-form-field>
        </form>
      </div>
      <div class="w-50-2">
        <fc-report-form
          [eligibilityForm]="fakeForm"
          [reportConfig]="getPreviewConfig()"
          [isPreview]="true"></fc-report-form>
      </div>
    </div>
  </div>
</div>
